import logo from "@/assets/logo.png";
import {Logo} from "@/components/icons";
import UserMenu from "@/components/UserMenu";
import { DashboardOrgSelector } from "@/app/DashboardOrgSelector";
import { LocalTimezoneChip } from "@/components/LocalTimezoneChip";
import { Link } from "react-router-dom";


export default function Navbar({user}: { user: { id: number, username: string; role: string } | null }) {
    return (
        <div className="flex items-center h-16 px-4 header relative bg-card border-b border-border/60 shadow-sm">
            <div className="absolute top-0 left-0 right-0 h-[2px] bg-primary/70"/>
            <div className="flex items-center"/>
            <div className="flex-1 min-w-0 overflow-hidden flex justify-center gap-3">

                <Link to="/" className="flex items-center gap-3 group">
                    <Logo className="h-8  w-auto" />
                </Link>
            </div>
            {/* Org switcher lives in the header's right cluster, in the same flex row as
                the user menu — so it never overlaps and is clickable with a normal mouse
                (the legacy `.header` fixed overlay previously covered it). */}
            <div className="flex items-center ml-auto gap-3 shrink-0">
                <LocalTimezoneChip />
                <DashboardOrgSelector />
                {/*<ThemePicker />*/}
                <UserMenu user={user}/>
            </div>
        </div>)
}